import styled from 'styled-components';
import { tokens } from '@companycam/slab';

export const ListTypeButton = styled.div`
  flex-direction: row;
  align-items: center;
  background-color: ${({ selected }) => (selected ? '#D7F0FF' : 'white')};
  border: ${({ selected }) =>
    selected ? tokens.color_button_background_primary_le : tokens.color_button_background_subtle_le};
  border-width: 1.5px;
  border-radius: 8px;
  margin: 4px;
`;

export const LargeParagraph = styled.p`
  font-weight: 400;
  font-size: 22px;
  line-height: 1.5;
  color: ${tokens.color_text_subtle_le};
`;

export const LightTextSmall = styled.p`
  font-size: 12px;
  color: ${tokens.color_text_subtle_le};
`;

export const Text = styled.p`
  font-size: 16px;
  margin: 0;
  color: ${tokens.color_text_subtle_le};
`;

export const SmallText = styled.p`
  font-size: 12px;
  margin: 0;
  color: ${tokens.color_text_subtle_le};
`;
